import { Modal } from 'antd'
import React from 'react'

const DeleteVenueDevice = ({
  visible,
  confirmLoading,
  onOk,
  fieldData,
  onCancel,
  project
}) => {
  return (
    <Modal
      title='DELETE DEVICE'
      visible={visible}
      onOk={() => {
        onOk({
          deviceId: fieldData?.id,
          project,
          email: fieldData?.email
        })
      }}
      onCancel={onCancel}
      className='general-modal delete-venue-device'
      okText='Delete'
      cancelText='Cancel'
      okButtonProps={{
        disabled: confirmLoading
      }}
      confirmLoading={confirmLoading}
    >
      Are you sure you want to delete this device ?
    </Modal>
  )
}

export default DeleteVenueDevice
